import React, { useEffect, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { TableUrlPagination } from '../../../../ui'
import { paymentDataPreparation } from '../../logics'
import { PAYMENTS_TABLE_COLUMNS } from '../../constants'
import { useRowSelector } from '../../../loader/hooks'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const PaymentsTable = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const navigate = useNavigate()
  const paymentsLoader = useSelector((state) => state.loader.payments)
  const combos = useSelector((state) => state.combos)
  const role = useSelector((state) => state.global.role)
  const permissions = useSelector((state) => state.global.permissions)
  const hasGestionSspp = permissions?.gestion_sspp

  const data = paymentsLoader?.data?.pagos || []
  const totalEntries = paymentsLoader?.data?.total_pagos
  const search = paymentsLoader?.config?.params
  const loading = paymentsLoader?.loading

  const { selection, addSelection } = useRowSelector({
    identifier: 'payments',
    selectFilter: (state) => state?.data?.pagos,
    idField: 'pago_id',
  })

  useEffect(() => {
    if (selection.length) {
      addSelection([])
    }
  }, [])

  const handleGoToDetail = (e, row) => {
    if (role !== 'sir') {
      navigate(`/applications/${row.sol_id}`)
    } else {
      navigate(`sir/${row.sol_id}`)
    }
  }

  const handleSelectRows = useCallback(
    (rows) => {
      addSelection(rows)
    },
    [addSelection]
  )

  const formattedColumns = useMemo(() => {
    return PAYMENTS_TABLE_COLUMNS.map((column) => {
      const baseColumn = {
        accessorKey: column.field,
        header: formatMessage({ id: `pages.payments.table.columns.${column.field}.title` }),
        size: column.width,
        minSize: column.width,
        maxSize: column.width,
      }

      if (column.field === 'actions') {
        return {
          ...baseColumn,
          header: formatMessage({ id: 'global.actions' }),
          Cell: (props) => <span>Acciones</span>, // Replace with actual actions component
          muiTableBodyCellProps: { align: 'center' },
        }
      }

      if (column.comboId && combos[column.comboId]?.data) {
        const lookup = getLookup(combos[column.comboId].data)
        return {
          ...baseColumn,
          Cell: ({ cell }) => {
            const value = cell.getValue()
            return <span>{lookup[value] ?? value ?? '--'}</span>
          },
        }
      }

      return {
        ...baseColumn,
        Cell: ({ cell }) => <span>{cell.getValue() ?? '--'}</span>,
      }
    })
  }, [combos, formatMessage])

  const processedData = useMemo(() => paymentDataPreparation(data, { intl }), [data, intl])

  const finalTableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: true,
      draggable: false,
    }),
    []
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={finalTableOptions}
      totalEntries={totalEntries}
      search={search}
      data={processedData}
      isLoading={loading}
      onSelectionChange={handleSelectRows}
      onRowClick={role !== 'soporte_procesos' && !hasGestionSspp ? handleGoToDetail : null}
    />
  )
}
